// removed by extract-text-webpack-plugin
module.exports = {"Cacao":"#645B57","button":"Gac6747 Gb69063 G43478c G6df9f5","top-right":"G775e65"};